import { SUPPORTED_LANGS } from './supported-langs'
import type { SupportedLang } from './supported-langs'

const NON_ENGLISH_SUPPORTED_LANGS = SUPPORTED_LANGS.filter((lang) => lang !== 'en')

export function getNormalizedTranslationLang(lang: unknown): SupportedLang {
  if (typeof lang === 'string' && (SUPPORTED_LANGS as readonly string[]).includes(lang)) {
    return lang as SupportedLang
  }

  return 'en'
}

export function getEnabledTranslationLangs(flagValue: unknown) {
  if (!Array.isArray(flagValue)) return []

  const enabledLangs = new Set(
    flagValue.filter(
      (lang): lang is (typeof NON_ENGLISH_SUPPORTED_LANGS)[number] =>
        typeof lang === 'string' &&
        NON_ENGLISH_SUPPORTED_LANGS.includes(lang as (typeof NON_ENGLISH_SUPPORTED_LANGS)[number])
    )
  )

  return NON_ENGLISH_SUPPORTED_LANGS.filter((lang) => enabledLangs.has(lang))
}
